import React from 'react';

import styled from 'styled-components';

const StyledRow = styled.div<{ $firstRow: boolean }>`
  ${(props) => `
  border-bottom: 1px solid ${props.theme.colors.darkGray};
  display: flex;
  font-family: ${props.theme.fonts.default};
  height: 3.125rem;
  justify-content: space-between;
  padding: 0.625rem 0.625rem 0 0.625rem;

  ${
    props.$firstRow &&
    `
      background: ${props.theme.colors.lighterGray};
      > div {
        &:last-child {
          color: ${props.theme.colors.primaryRed};
        }
      }
  `
  }

  > div {
    &:first-child {
      font-size: 1rem;
    }

    &:last-child {
      font-size: 1.125rem;
      font-weight: 600;
    }
  }

  sup {
    padding-left: 0.25rem;
  }
`}
`;

interface ComparisonRowProps {
  data: string;
  name: string;
  firstRow?: boolean;
  footnote?: number;
}

function ComparisonRow({ name, data, firstRow, footnote }: ComparisonRowProps) {
  return (
    <StyledRow $firstRow={!!firstRow}>
      <div>
        {name}
        {footnote && <sup>{footnote}</sup>}
      </div>
      <div>${data}</div>
    </StyledRow>
  );
}

export default ComparisonRow;
